import { Injectable } from '@angular/core';
import { finalize, Observable, shareReplay } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class InFlightRequestCacheService {
    private readonly inFlight$ = new Map<string, Observable<unknown>>();

    getOrCreate$<T>(key: string, factory: () => Observable<T>): Observable<T> {
        const existing = this.inFlight$.get(key) as Observable<T> | undefined;
        if (existing) {
            return existing;
        }

        const request$ = factory().pipe(
            shareReplay({ bufferSize: 1, refCount: true }),
            finalize(() => {
                this.inFlight$.delete(key);
            })
        );

        this.inFlight$.set(key, request$);
        return request$;
    }

    clear(key: string) {
        this.inFlight$.delete(key);
    }

    clearAll() {
        this.inFlight$.clear();
    }
}
